export enum RoomType {
    CHANNEL = 'c',
    PRIVATE_GROUP = 'p',
    DIRECT_MESSAGE = 'd',
    LIVE_CHAT = 'l',
}
